import PropTypes from 'prop-types';

/**
 * 'City, Country' in a table column (the levels table, the Subsidiaries table). Both parts stay on
 * one line when they fit; otherwise the country moves to a second line and the comma stays at the
 * end of the first. A part wider than the column is cut with …, and the title holds the whole
 * location.
 *
 * @param {Object} props
 * @param {string[]} props.parts - [city, country], or one of them (locationPartsOf)
 */
const LocationText = ({ parts }) => {
  const [first, second] = parts;
  return (
    <span className="sg-location" title={parts.join(', ')}>
      <span className="sg-location-part">
        <span className="sg-location-text">{first}</span>
        {second && ','}
      </span>
      {/* The space is for copied text and screen readers; the layout ignores it (column-gap). */}
      {second && (
        <>
          {' '}
          <span className="sg-location-part">
            <span className="sg-location-text">{second}</span>
          </span>
        </>
      )}
    </span>
  );
};

LocationText.propTypes = {
  parts: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default LocationText;
